import { render } from "./newVariableComponent.vue?vue&type=template&id=32841c4c&scoped=true"
import script from "./newVariableComponent.vue?vue&type=script&lang=js"
export * from "./newVariableComponent.vue?vue&type=script&lang=js"

import "./newVariableComponent.vue?vue&type=style&index=0&id=32841c4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32841c4c"]])

export default __exports__